<template>
  <div class="merryXmas">
    <div class="xmasSection">
      <img src="./merryXmas/xmas_01.jpg" class="xmasImg">
      <img src="./merryXmas/xmas_02.jpg" class="xmasImg">
    </div>
    <div class="lottery">
      <div class="lotteryBlock">
        <div class="content">
          <div class="lottery-item" :class="index === 0 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img01.png" alt>
            </div>
            <div class="wdContent">现金红包</div>
          </div>
          <div class="lottery-item" :class="index === 1 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img03.png" alt>
            </div>
            <div class="wdContent">暖冬办公室午睡毯</div>
          </div>
          <div class="lottery-item" :class="index === 2 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img06.png" alt>
            </div>
            <div class="wdContent">恐龙蛋100个</div>
          </div>
          <div class="lottery-item" :class="index === 7 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img02.png" alt class="maxImg">
            </div>
            <div class="wdContent">Jurlique身体乳</div>
          </div>
          <div class="lottery-btn" @click="startLottery">
            <p>立即</p>
            <p>抽奖</p>
          </div>
          <div class="lottery-item" :class="index === 3 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img05.png" alt>
            </div>
            <div class="wdContent">天猫精灵</div>
          </div>
          <div class="lottery-item" :class="index === 6 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img06.png" alt>
            </div>
            <div class="wdContent">恐龙蛋15个</div>
          </div>
          <div class="lottery-item" :class="index === 5 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img04.png" alt class="maxImg">
            </div>
            <div class="wdContent">2019年国家地理台历</div>
          </div>
          <div class="lottery-item" :class="index === 4 ? `active` : ``">
            <div class="imgBlock">
              <img src="./merryXmas/img06.png" alt>
            </div>
            <div class="wdContent">恐龙蛋50个</div>
          </div>
        </div>
      </div>
    </div>
    <div class="xmasSection">
      <img src="./merryXmas/xmas_03.jpg" class="xmasImg">
      <img src="./merryXmas/xmas_04.jpg" class="xmasImg">
    </div>
    <prize-list class="prizeList" :lists="list"></prize-list>
    <div class="myPrizeBtn" @click="showList"></div>
    <div class="xmasSection">
      <img src="./merryXmas/xmas_05.jpg" class="xmasImg">
      <img src="./merryXmas/xmas_06.jpg" class="xmasImg">
    </div>
    <lottery-dialog
      :visible="showToast"
      :imgPath="(lotteryRes&&lotteryRes.id)&&priceList[lotteryRes.id].imgPath"
      :keyword="(lotteryRes&&lotteryRes.id == 1)?lotteryRes.command:''"
      @close="closeToast"
    ></lottery-dialog>
    <my-prize :visible="showPrize" :list="myPrizeList" @close="closeList"></my-prize>
    <no-chance :visible="nochance" :code="lotteryRes&&lotteryRes.status_code" @close="closeChance"></no-chance>
  </div>
</template>

<script>
import Util from "../../../../../src/libs/util";
import * as lottery from "./merryXmas/list";
import PrizeList from "./merryXmas/templ/prizelist";
import LotteryDialog from "./merryXmas/templ/lottery-dialog";
import MyPrize from "./merryXmas/templ/my-prize";
import NoChance from "./merryXmas/templ/no-chance";
export default {
  data() {
    return {
      index: -1, // 当前转动到哪个位置，起点位置
      count: 8, // 总共有多少个位置
      timer: 0, // 每次转动定时器
      speed: 200, // 初始转动速度
      times: 0, // 转动次数
      cycle: 50, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
      prize: -1, // 中奖位置
      click: true,
      showToast: false,
      showPrize: false,
      toastType: "luck",
      priceList: lottery.productList,
      lotteryRes: null,
      list: [],
      myPrizeList: [],
      nochance: false
    };
  },
  components: {
    PrizeList,
    LotteryDialog,
    MyPrize,
    NoChance
  },
  methods: {
    // 开始抽奖
    startLottery() {
      if (!this.click) {
        return;
      }
      this.closeToast();
      this.speed = 200;
      this.click = false;
      this.getLottery();
    },
    // 开始转动
    startRoll() {
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (this.times > this.cycle + 10 && this.prize === this.index) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        setTimeout(()=>{
          this.prize = -1;
          this.times = 0;
          this.click = true;
          this.showToast = true;
          this.toastType = "comeOn";
          // console.log("你已经中奖了");
        },800)
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if (this.times === this.cycle) {
          // 随机获得一个中奖位置
          const index = this.priceList[this.lotteryRes.id].index;
          this.prize = index;
          if (this.prize > 7) {
            this.prize = 7;
          }
          // console.log( `中奖位置${this.prize},中奖产品${this.priceList[this.lotteryRes.id].title}`);
        } else if (
          this.times > this.cycle + 10 &&
          ((this.prize === 0 && this.index === 7) ||
            this.prize === this.index + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }

        if (this.speed < 40) {
          this.speed = 40;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },
    // 每一次转动
    oneRoll() {
      let index = this.index; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.index = index;
    },
    // 关闭弹出框
    closeToast() {
      this.showToast = false;
      document.getElementsByTagName('body')[0].style.overflow='auto'
    },
    //我的中奖记录
    showList() {
      this.getMyList();
      this.showPrize = true;
    },
    closeList() {
      this.showPrize = false;
      document.getElementsByTagName('body')[0].style.overflow='auto'

    },
    //没有抽奖记录
    closeChance() {
      this.nochance = false;
      document.getElementsByTagName('body')[0].style.overflow='auto'
    },
    async getLottery() {
      let ret = await Util.ajax.post('/operation_api/egg_activity/luck_draw')
      this.lotteryRes = ret;
      if (!this.lotteryRes.status_code&&this.lotteryRes.id) {
        document.getElementsByTagName('body')[0].style.overflow='hidden'
        this.startRoll();
      } else {
        this.nochance = true;
        this.click = true;
      }
    },
    async getPrizeList() {
      let ret = await Util.ajax.get('/operation_api/egg_activity/luck_draw')
      this.list = ret;
    },
    async getMyList() {
      let ret = await Util.ajax.get('/operation_api/egg_activity/luck_draw/my_record')
      this.myPrizeList = ret;
    }
  },
  created() {
    this.getPrizeList();
  }
};
</script>

<style lang="scss" scoped>
.merryXmas {
  background: #f9f9f8;
  .xmasSection {
    width: 100%;
    max-width: 1920px;
    min-width: 1200px;
    margin: 0 auto;
    position: relative;
    overflow-x: hidden;
    .xmasImg {
      width: 100%;
      min-width: 1920px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      display: block;
    }
  }
  .lottery {
    position: relative;
    z-index: 5;
    height: 0;
    .lotteryBlock {
      width: 1200px;
      height: 1388px;
      background: url("./merryXmas/lotteryBg.jpg");
      padding-top: 294px;
      margin: 0 auto;
      position: absolute;
      top: 232px;
      left: 50%;
      margin-left: -600px;
      .content {
        width: 840px;
        height: 813px;
        margin: 0 187px;
        padding-top: 15px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .lottery-item {
          width: 257px;
          height: 248px;
          border: solid 4px rgb(48, 71, 103);
          border-radius: 10px;
          background: #d0d0d0;
          box-shadow: 0px 7px 27px 0px rgba(9, 2, 4, 0.6);
          cursor: pointer;
          &.active {
            background-color: #fff;
          }
          .imgBlock {
            height: 185px;
            position: relative;
            img {
              position: absolute;
              top: 32px;
              left: 0;
              bottom: 0;
              right: 0;
              margin: auto;
            }
            .maxImg {
              top: 3px;
            }
          }
          .wdContent {
            height: 34px;
            line-height: 34px;
            text-align: center;
            font-size: 14px;
            color: #31496a;
            text-transform: uppercase;
            -moz-transform: matrix(
              1.72391728857481,
              0,
              0,
              1.74099292357974,
              0,
              0
            );
            -webkit-transform: matrix(
              1.72391728857481,
              0,
              0,
              1.74099292357974,
              0,
              0
            );
            -ms-transform: matrix(
              1.72391728857481,
              0,
              0,
              1.74099292357974,
              0,
              0
            );
            transform: matrix(1.72391728857481, 0, 0, 1.74099292357974, 0, 0);
          }
        }
        .lottery-btn {
          width: 257px;
          height: 248px;
          background: #406da6;
          box-shadow: 0 4px 7px 1px rgba(9, 2, 4, 0.6);
          border-radius: 10px;
          color: #fff;
          text-align: center;
          font-size: 55px;
          line-height: 66px;
          padding-top: 50px;
          cursor: pointer;
          transition: background-color 0.2s;
          &:hover{
            background: rgb(81, 145, 228);
          }
        }
      }
    }
  }
  .prizeList {
    margin: -40px auto 130px;
    position: relative;
    z-index: 5px;
  }
  .myPrizeBtn {
    width: 360px;
    height: 68px;
    margin: 131px auto 103px;
    background: url("./merryXmas/myprizeBtn.png");
    cursor: pointer;
  }
}
</style>
